import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

@Injectable()
export class DBUserService extends RequestBase {
    BasePath = 'config/api/dbusers';

    ReadUsers(): Observable<any> {
        return this.http.get(this.API_BASE_URL + this.BasePath + '/ReadUsers', this.options);
    }

    GetUserInfo(id: string): Observable<any> {
        return this.http.get(this.API_BASE_URL + this.BasePath + '/GetUserInfo?id=' + id, this.options);
    }

    CreateNewUser(newUser: any): Observable<any> {
        return this.http.post(this.API_BASE_URL + this.BasePath + '/CreateNewUser', newUser, this.options);
    }

    UpdateUser(newUser: any): Observable<any> {
        return this.http.post(this.API_BASE_URL + this.BasePath + '/UpdateUser', newUser, this.options);
    }

    ResetUserPasswordAdvanced(request: any): Observable<any> {
        return this.http.post(this.API_BASE_URL + this.BasePath + '/ResetUserPasswordAdvanced', request, this.options);
    }
}